import { useCachedWorkspacesQuery } from 'front-end/src/app/stores/useCachedWorkspacesQuery'
import { ButtonDanger, ButtonLight } from 'front-end/src/components'
import { CampaignModel } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import React from 'react'

import { t, Trans } from '@lingui/macro'

import { staticLinks } from '../../../../shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import { Modal } from '../../components/common/modal/Modal'
import { useDeleteWorkspaceMutation } from './DeleteWorkspaceModal.codegen'

interface IDeleteWorkspaceModalProps {
  workspaceId: number
  deleteModalVisible: boolean
  setDeletedModalVisible: (boolean) => void
  relatedActiveCampaigns: Array<Partial<CampaignModel> & { author: any }>
  resetRelatedActiveCampaigns: () => void
}

export const DeleteWorkspaceModal = ({
  workspaceId,
  deleteModalVisible,
  setDeletedModalVisible,
  relatedActiveCampaigns,
  resetRelatedActiveCampaigns
}: IDeleteWorkspaceModalProps) => {
  const [deleteWorkspace] = useDeleteWorkspaceMutation()
  const { refetch } = useCachedWorkspacesQuery()

  return (
    <Modal
      header={t`Delete workspace`}
      className="DeleteWorkspaceModal"
      show={deleteModalVisible}
      controls={[
        <ButtonLight onClick={() => setDeletedModalVisible(false)} key={1}>
          <Trans>Cancel</Trans>
        </ButtonLight>,
        <ButtonDanger
          key={2}
          onClickAsync={async () => {
            await deleteWorkspace({
              variables: {
                workspaceId
              }
            })
            refetch()
            navigateTo(staticLinks.home)
          }}
        >
          <Trans>Delete this workspace</Trans>
        </ButtonDanger>
      ]}
      onHide={() => setDeletedModalVisible(false)}
      onHidden={() => resetRelatedActiveCampaigns()}
    >
      <p>
        <Trans>
          Deleting this workspace will remove access to any resources within it,
          and delete any existing records of learning undertaken within it.
        </Trans>
      </p>
      {relatedActiveCampaigns && relatedActiveCampaigns.length > 0 && (
        <>
          <br />
          <p>
            <Trans>
              This workspace appears in some campaigns' filters. Deleting this
              workspace will result in deactivating these campaigns:
            </Trans>
          </p>
          <ul>
            {relatedActiveCampaigns.map((campaign) => {
              return (
                <li key={campaign.id}>
                  {campaign.name} (
                  <b>
                    {campaign.author.email
                      ? campaign.author.email
                      : campaign.author.account_name}
                  </b>
                  )
                </li>
              )
            })}
          </ul>
        </>
      )}
      <br />
      <p>
        <strong>
          <Trans>This action cannot be undone</Trans>
        </strong>
      </p>
    </Modal>
  )
}
